import styled from "styled-components";

import { PageContainer } from "app/pages/industry-analysis/common/styledComponents";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import { Body } from "./components/Body";
import { Footer } from "./components/Footer";
import { GroupName } from "./components/GroupName";
import { Subtitle } from "./components/Subtitle";

const Container = styled(PageContainer)`
    padding: 20px 24px 16px 24px;
    box-sizing: border-box;
    width: 800px;
    gap: 12px;
`;

export const KeywordListComposerEditor = ({ onCloseConfirm }: { onCloseConfirm: VoidFunction }) => {
    return (
        <Container>
            <FlexColumn gap="8px">
                <GroupName />
                <Subtitle />
            </FlexColumn>
            <FlexColumn gap="16px">
                <Body />
                <Footer onClose={onCloseConfirm} />
            </FlexColumn>
        </Container>
    );
};
